// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__a7LYf","boxTitle":"Qualiphy_boxTitle__17SdA","box":"Qualiphy_box__3Lahj","toggleWrap":"Qualiphy_toggleWrap__1g0f-"};